<template>
	<div class="stpf888">
        <main>
            <span>起止日期： </span>
            <el-date-picker
                v-model="time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd">
            </el-date-picker>
            <span style="margin-left: 20px;">请选择公司：</span>
            <el-select v-model="org" placeholder="请选择"  clearable >
            <el-option
                v-for="item in options"
                :label="item"
                :value="item">
                </el-option>
            </el-select>

            <el-button style="margin-left:20px" type="success" icon="el-icon-search" @click="search()">搜索</el-button>
            <el-button type="info" icon="el-icon-download" @click="daochu()">导出</el-button>

        </main>
        
        <el-card style="border: solid #ccc 1px">
            <el-table
                :data="tableData"
                stripe
                border
                height="60vh"
                style="width: 200%">

                <el-table-column
                    width="160"
                    prop="create_time"
                    label="提交时间">
                </el-table-column>

                <el-table-column
                    prop="org"
                    label="公司">
                </el-table-column>

                <el-table-column
                    prop="value1"
                    label="卫生">
                </el-table-column>

                <el-table-column
                    prop="value2"
                    label="品种">
                </el-table-column>

                <el-table-column
                    prop="value3"
                    label="分量">
                </el-table-column>

                <el-table-column
                    prop="value4"
                    label="口感">
                </el-table-column>

                <el-table-column
                    prop="value5"
                    label="味道">
                </el-table-column>

                <el-table-column
                    prop="value6"
                    label="新鲜度">
                </el-table-column>

                <el-table-column
                    prop="value7"
                    label="餐碗筷">
                </el-table-column>

                <el-table-column
                    prop="value8"
                    label="荤素">
                </el-table-column>

                <el-table-column
                    prop="value9"
                    label="态度">
                </el-table-column>

                <el-table-column
                    prop="value10"
                    label="体验">
                </el-table-column>

                <el-table-column
                    prop="message"
                    label="意见">
                </el-table-column>

                <el-table-column label="总分">
                    <template slot-scope="scope">
                        {{ 
                            Number(scope.row.value1) + Number(scope.row.value2) +
                            Number(scope.row.value3) + Number(scope.row.value4) +
                            Number(scope.row.value5) + Number(scope.row.value6) +
                            Number(scope.row.value7) + Number(scope.row.value8) +
                            Number(scope.row.value9) + Number(scope.row.value10)
                        }}
                    </template>
                </el-table-column>

            </el-table>

            <el-pagination
                style="margin:20px 0"
                background
                @current-change="handleCurrentChange"
                :current-page="current_page"
                :page-size="per_page"
                layout="prev, pager, next"
                :total="total">
            </el-pagination>

        </el-card>    

    </div>
</template>

<script>
    import shitang from "../config/option.js"
    import { url } from '../router/api';
	export default{
		data(){
			return{
                total: 1,
                per_page: 50,
                current_page: 1,
                tableData: [],
                time:[],
                options:shitang.shitang3,
                org:'',
            }
        },
        async mounted() {
            var date = new Date();
            date.setTime(date.getTime());
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
            var D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate());
            var time1 = Y + M + '01'
            var time2 = Y + M +D
            this.time.push(time1)
            this.time.push(time2)

            await this.getList()
        },
		methods: {
           
            search() {
                this.current_page = 1
                this.getList()
            },

            handleCurrentChange(val) {
                this.current_page = val;
                this.getList();
            },

            daochu() {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: '加载中',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                var time1 = ''
                var time2 = ''
                if(this.time) {
                    time1 = this.time[0] + ' 00:00:00'
                    time2 = this.time[1] + ' 23:59:59'
                }
                this.axios.get(url +'complaint/stpfSearch', {
                    params:{
                        export:1,
                        time1:time1,
                        time2:time2,
                        org:this.org,
                        page:this.current_page,
                        per_page:this.per_page,
                    },
                    responseType: 'blob',
                    
                }).then(res=> {
                    const data = res.data 
                    if (Object.prototype.toString.call(data) === '[object Blob]' && data.type.includes('application/vnd.ms-excel')) { 
                        const blob = res.data
                        const a = document.createElement('a')
                        let binaryData = [];
                        binaryData.push(blob);
                        const url= window.URL.createObjectURL(new Blob(binaryData));
                        a.href = url
                        a.download = '食堂满意度.csv'
                        a.click()
                        window.URL.revokeObjectURL(url)
                    }else{
                        this.$message.error('下载失败')
                    }
                    loading.close();
                }).catch(err=> {
                    loading.close();
                    console.log(err);
                });
            },
            
            getList() {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: '加载中',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

                var time1 = ''
                var time2 = ''
                if(this.time) {
                    time1 = this.time[0] + ' 00:00:00'
                    time2 = this.time[1] + ' 23:59:59'
                }
                this.axios.get(url+'complaint/stpfSearch', {
                    params:{
                        time1:time1,
                        time2:time2,
                        org:this.org,
                        page:this.current_page,
                        per_page:this.per_page,
                    }
                }).then(res=> {
                    loading.close();
                    this.tableData = res.data.data.data
                    this.total = res.data.data.total
                }).catch(err=> {
                    loading.close();
                    console.log(err);
                });
            },

           
        }

    }
</script>

<style scoped="scoped" lang='less'>
    .stpf888 {
        padding-left: 10px;
        span {
            font-size: 12px;
        }
    }
    .stpf888 .el-input {
        width:140px;
        margin-right: 20px;
    }
 
    .stpf888 .el-select {
        width:140px;
        margin-right: 20px;
    }
    .stpf888 main {
        margin-bottom: 20px;
    }
    .stpf888 .el-pagination {
        white-space: nowrap;
        padding: 2px 5px;
        color: #303133;
        float: right;
        font-weight: 700;
    }
</style>

